<div class="flex justify-between items-center border-b px-4 sm:px-8 h-16 w-full overflow-x-hidden">
  <div class="flex justify-start items-center gap-2 cursor-pointer" (click)="redirectSite()">
    <img class="" src="../../../assets/logos/logo.svg" alt="kc-logo" />
  </div>
  <div class="flex items-center gap-2">
    @if (espaceClient) {
      <button
        class="border-2 border-primary text-primary h-10 rounded-md hover:bg-primary/30 px-1 sm:px-4"
        (click)="redirectEspaceClient()"
        type="button"
      >
        <div class="flex items-center gap-2">
          <mat-icon svgIcon="feather:user-circle"></mat-icon>
          <span class="hidden sm:flex text-[12px] font-bold">Espace client</span>
        </div>
      </button>
    }
    @if (aide) {
      <button
        class="bg-primary h-10 text-white rounded-md hover:bg-primary/30 hover:text-black px-1 sm:px-4"
        type="button"
        (click)="openDialog()"
      >
        <div class="flex items-center">
          <span class="hidden sm:flex text-[12px] font-bold">Besoin d'aide ?</span>
          <mat-icon class="flex sm:hidden" svgIcon="mat_solid:help_outline"></mat-icon>
        </div>
      </button>
    }
  </div>
  @if (admin) {
    <button class="px-1" type="button" mat-flat-button (click)="logout()">
      <div class="flex items-center space-x-4">
        <mat-icon svgIcon="mat_solid:logout"></mat-icon>
      </div>
    </button>
  }
</div>
